import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";
import http from "./HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/product";

export default class ProductsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	changePin = (type, id) => {
		return http.put(`${apiEndpoint}/${type}/${id}`);
	};
}
